module.exports = __webpack_public_path__ + "img/抓狂.c763703f.gif";